import App from './components/App';
import Choose from './components/Choose';
import Closer from './components/Closer';
import Designed from './components/Designed';
import Energize from './components/Energize';
import Energy from './components/Energy';
import FirstKv from './components/FirstKv';
import FormMeets from './components/FormMeets';
import Maximum from './components/Maximum';
import MoveCloser from './components/MoveCloser';
import MultiSource from './components/MultiSource';
import Nav from './components/Nav';
import PortableDesign from './components/PortableDesign';
import PowerOutage from './components/PowerOutage';
import Smarter from './components/Smarter';
import Solutions from './components/Solutions';
import Tc from './components/Tc';
import Tip from './components/Tip';
import TriShield from './components/TriShield';
import Uninterrupted from './components/Uninterrupted';
import WholeHome from './components/WholeHome';

export default function IndexDynamic() {
    return (
        <>
            <Nav />
            <Tip />
            <FirstKv />
            <Energize />
            <WholeHome />
            <Uninterrupted />
            <MultiSource />
            <PowerOutage />
            <FormMeets />
            <Designed />
            <PortableDesign />
            <Energy />
            <TriShield />
            <Maximum />
            <div style={{ background: '#000' }}>
                <MoveCloser />
                <Smarter />
                {/* <SeriesEcoFlow /> */}
                <Closer />
                <Solutions />
                <Choose />
                <App />

                <Tc />
            </div>
        </>
    );
}
